/**************************************************************************************************/
/** @import Helpers/Components                                                                   **/
/**************************************************************************************************/
import { BaseElement } from '@/Helpers/Components/DataForm/BaseElement'

/**************************************************************************************************/
/** @export Class @name BaseInput                                                                **/
/**************************************************************************************************/
export class BaseInput extends BaseElement
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	private events: { [key: string]: Function }
	private type: string
	private value: string

	/*************************************************/
	/** @Constructor                                **/
	/*************************************************/
	constructor()
	{
		super()
		this.events = {}
		this.type = 'BaseInput'
		this.value = ''
	}

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	public get Events() : { [key: string]: Function }
	{
		return this.events
	}

	public get Type() : string
	{
		return this.type
	}

	public set Type(value)
	{
		this.type = value
	}

	public get Value() : string
	{
		return this.value
	}

	public set Value(value)
	{
		this.value = value
	}

	public addEvent(eventName: string, func: Function) : this
	{
		this.events[eventName] = func
		return this
	}

	public resolveInputState(self: any) : boolean | null
	{
		if (self?.value === '') return null
		return true
	}

	public setParamsFormatter(formatter: Function) : this
	{
		this.Params.formatter = formatter
		return this
	}

	public setParamsType(type: string) : void
	{
		this.Params.type = type
	}
}